module.exports = __webpack_public_path__ + "img/about.8a35963d.jpg";